export default __webpack_public_path__ + "static/media/previous.4479b6fa.svg";